var map = {
	"./Article": 23,
	"./Article.jsx": 23,
	"./ArticleCompleteModal": 13,
	"./ArticleCompleteModal.jsx": 13,
	"./ArticleEditor": 25,
	"./ArticleEditor.jsx": 25,
	"./ConfettiModal": 14,
	"./ConfettiModal.jsx": 14,
	"./DailyReminder": 26,
	"./DailyReminder.jsx": 26,
	"./DashboardArticles": 27,
	"./DashboardArticles.jsx": 27,
	"./Demo": 28,
	"./Demo.jsx": 28,
	"./FadeOutNotification": 9,
	"./FadeOutNotification.jsx": 9,
	"./GameSettings": 6,
	"./GameSettings.jsx": 6,
	"./GameStatus": 7,
	"./GameStatus.jsx": 7,
	"./LeveledUpModal": 8,
	"./LeveledUpModal.jsx": 8,
	"./Modal": 5,
	"./Modal.jsx": 5,
	"./PhraseEditor": 12,
	"./PhraseEditor.jsx": 12,
	"./PhraseSlideout": 29,
	"./PhraseSlideout.jsx": 29,
	"./Review": 30,
	"./Review.jsx": 30,
	"./Sentence": 4,
	"./Sentence.jsx": 4,
	"./ShareArticle": 15,
	"./ShareArticle.jsx": 15,
	"./SlideoutModal": 16,
	"./SlideoutModal.jsx": 16,
	"./SubscribeSuccessModal": 31,
	"./SubscribeSuccessModal.jsx": 31,
	"./TatoebaImporter": 32,
	"./TatoebaImporter.jsx": 32,
	"./TranslationsFormGroup": 18,
	"./TranslationsFormGroup.jsx": 18,
	"./VoiceList": 33,
	"./VoiceList.jsx": 33,
	"./WikipediaImporter": 34,
	"./WikipediaImporter.jsx": 34,
	"./WordsPerSentenceFromGroup": 17,
	"./WordsPerSentenceFromGroup.jsx": 17
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 40;